import * as React from 'react';
import { useEffect, useState } from 'react';
import { Person, fieldValidation } from '../../../amorg-common';
import { deletePerson, updatePerson } from '../../../api/personClientApi';
import { MessageCard } from '../../../designSystem/Message';
import { Button } from '../../../designSystem/button/Button';
import { ButtonRow } from '../../../designSystem/button/ButtonRow';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { TextSaveField } from '../../../designSystem/formField/text/TextSaveField';

type PersonEditorProps = {
    person: Person,
    onUpdated: () => void,
    onDeleted:()=>void,
    onClose:() => void,
}
export function PersonEditor(props:PersonEditorProps):JSX.Element
{

    const [name, setName] = useState("");
    const [role, setRole] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    
    const [nameIsValid, setNameIsValid] = useState(true);
    const [roleIsValid, setRoleIsValid] = useState(true);
    const [emailIsValid, setEmailIsValid] = useState(true);
    const [phoneIsValid, setPhoneIsValid] = useState(true);

    const [deleteError, setDeleteError] = useState(false);
    

    useEffect(() => {
    
        setName(props.person.name)
        setRole(props.person.role)
        setEmail(props.person.email)
        setPhone(props.person.phone)

        setDeleteError(false);
    
    }, [props.person])

    async function handleDeleteClick()
    {
        setDeleteError(false);    
        const result = await deletePerson(props.person.id)
        
        if( result.isSuccess){
            props.onDeleted()
        }
        else if(result.errorMessage === 'deletePerson_id_in_use_as_facility_owner')
        {
            setDeleteError(true)
        }
    }

    return (
        <>
            <Flex gap={24} flexDirection="column">
                
                {deleteError && 
                    <MessageCard variant='error'>
                        Personen kan ikke slettes, da personen er tilknyttet en eller flere lokationer som ansvarlig.
                    </MessageCard>
                }

                <TextSaveField 
                    value={name} 
                    onSave={ async (value) => {
                        setName(value)
                        const fieldValid = fieldValidation.person.name(value);
                        setNameIsValid(fieldValid);
                        if( fieldValid === true && value !== name){
                            await updatePerson(props.person.id, value, role, email, phone )
                        }
                        props.onUpdated();
                        
                    }} 
                    label={"Navn*"}
                    errorMessage={!nameIsValid ? "Maks. 100 tegn" : "" } 
                />

                
                <TextSaveField 
                    value={role} 
                    onSave={ async (value) => {
                        setRole(value)
                        const fieldValid = fieldValidation.person.role(value);
                        setRoleIsValid(fieldValid);
                        if( fieldValid === true && value !== role){
                            await updatePerson(props.person.id, name, value, email, phone )
                        }
                        props.onUpdated();
                    }} 
                    label={"Rolle"}
                    errorMessage={!roleIsValid ? "Maks. 100 tegn" : ""} />
              

                <TextSaveField 
                    value={email} 
                    onSave={ async (value) => {
                        setEmail(value)
                        const fieldValid = fieldValidation.person.email(value);
                        setEmailIsValid(fieldValid);
                        if( fieldValid === true && value !== email){
                            await updatePerson(props.person.id, name, role, value, phone )
                        }
                        props.onUpdated();
                    }} 
                    label={"Email"}
                    errorMessage={!emailIsValid ? "Må kun udfyldes med en gyldig email addresse" : ""} />

                <TextSaveField 
                    value={phone} 
                    onSave={ async (value) => {
                        setPhone(value)
                        const fieldValid = fieldValidation.person.phone(value);
                        setPhoneIsValid(fieldValid);
                        if( fieldValid === true && value !== phone){
                            await updatePerson(props.person.id, name, role, email, value )
                        }
                        props.onDeleted();
                    }} 
                    label={"Telefon"}
                    errorMessage={!phoneIsValid ? "Maks. 100 tegn" : ""} />

                <ButtonRow variant="space-between">
                    <Button variant="destructive-text"
                        onClick={handleDeleteClick}
                        icon="interface_actions_delete"
                        text="Slet" />

                    <Button
                        text="Luk"
                        variant="filled" 
                        onClick={ props.onClose }/>

                </ButtonRow>
            </Flex>
       
        
        </>
    );
}